<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>{{
      translationService.getLanguageText()
    }}</mat-panel-title>
    <mat-panel-description>
      {{ selectedLanguageName }}
    </mat-panel-description>
  </mat-expansion-panel-header>
  <mat-radio-group
    aria-label="Select an option"
    [(ngModel)]="selectedLanguage"
    (change)="changeLanguage()"
  >
    @for (language of languages; track language) {
      <mat-radio-button [value]="language.code">{{
        language.name
      }}</mat-radio-button>
    }
  </mat-radio-group>
</mat-expansion-panel>
